import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DnaReportBlock } from "./components/gene-report-block";
// import { BloodReportBlock } from "./components/blood-report-block";
// import { IdeaIcon } from "../../../../assets/icons/idea-icon";
// import { PrimaryButton } from "../../../../components/buttons/primary-button";
import { useUser } from "../../../../components/user/user-context";
import { HeadingText } from "../../../../components/text/heading-text";
import { ContentText } from "../../../../components/text/content-text";
import { SubheadingText } from "../../../../components/text/subheading-text";

const useStyles = makeStyles((theme: Theme) => ({
  contentText: {
    paddingTop: theme.spacing(3),
  },
  sectionTitle: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(2),
  },
  bulb: {
    width: 40,
    height: 40,
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(4),
  },
  tipContainer: {
    marginTop: theme.spacing(6),
    paddingBottom: theme.spacing(4),
  },
  bloodAnalysisButton: {
    fontSize: 18,
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    borderRadius: 10,
  },
}));

interface IUserReportsProps {}

export const UserReports: FunctionComponent<IUserReportsProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const user = useUser();
  const dnaReport = user.user?.dnaReport;

  return (
    <Grid container>
      <Grid item xs={12}>
        <HeadingText>{t("user_reports.header")}</HeadingText>
        <Grid item className={classes.contentText}>
          <ContentText light>{t("user_reports.subheader")}</ContentText>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.sectionTitle}>
        <SubheadingText>{t("user_reports.gene_analysis.title")}</SubheadingText>
      </Grid>
      {dnaReport && (
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={6} md={12} lg={6}>
            <DnaReportBlock dnaReport={dnaReport}></DnaReportBlock>
          </Grid>
        </Grid>
      )}
      {/* 
      ----- BLOOD ANALYSIS / NOT READY ------- 
      
      TODO: Re-add Blood analysis section when backend is ready. 

      <Grid item xs={12} className={classes.sectionTitle}>
        <SubheadingText>{t("user_reports.blood_analysis.title")}</SubheadingText>
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={6}>          
          <BloodReportBlock></BloodReportBlock>
        </Grid>
        <Grid item xs={6}>
          <BloodReportBlock></BloodReportBlock>
        </Grid>
        <Grid item xs={6}>
          <PrimaryButton className={classes.bloodAnalysisButton} fullWidth>
            {t("user_reports.blood_analysis.button")}
          </PrimaryButton>
        </Grid>
      </Grid>
      <Grid item container className={classes.tipContainer}>
        <Grid item className={classes.bulb}>
          <IdeaIcon />
        </Grid>
        <Grid item xs>
          <SubheadingText>{t("user_reports.tip.title")}</SubheadingText>
          <ContentText>{t("user_reports.tip.content")}</ContentText>
        </Grid>
      </Grid> 
      
      */}
    </Grid>
  );
};
